// Per-bucket fallback colour, used only when a feature's `properties.color` is
// missing. The actual paint comes from the backend on each zone (see
// geofencingZonesActions.js).
const FALLBACK_COLOURS = {
  grayArea: '#000000',
  parkingZones: '#21C378',
  noParkingZones: '#FB4747',
  speedLimitZones: '#5C22C9',
}

// Mapbox expression: read `properties.color` from the feature, fall back to the
// bucket default if absent.
function colourFromFeature(fallback) {
  return ['coalesce', ['get', 'color'], fallback]
}

// Bucket → source/layer wiring used by the switch below. Each entry is one
// fill layer (with translucent fill) + one line layer (solid outline).
const ZONE_LAYER_CONFIG = {
  grayAreaLayer: {
    source: 'grayAreaSource',
    dataKey: 'grayArea',
    fillLayerId: 'grayAreaLayer',
    outlineLayerId: 'grayAreaOutlineLayer',
    fallback: FALLBACK_COLOURS.grayArea,
    fillOpacity: 0.2,
  },
  parkingZonesLayer: {
    source: 'parkingZonesSource',
    dataKey: 'parkingZones',
    fillLayerId: 'parkingZonesLayer',
    outlineLayerId: 'parkingZonesOutlineLayer',
    fallback: FALLBACK_COLOURS.parkingZones,
    fillOpacity: 0.15,
  },
  noParkingZonesLayer: {
    source: 'noParkingZonesSource',
    dataKey: 'noParkingZones',
    fillLayerId: 'noParkingZonesLayer',
    outlineLayerId: 'noParkingZonesOutlineLayer',
    fallback: FALLBACK_COLOURS.noParkingZones,
    fillOpacity: 0.15,
  },
  speedLimitZonesLayer: {
    source: 'speedLimitZonesSource',
    dataKey: 'speedLimitZones',
    fillLayerId: 'speedLimitZonesLayer',
    outlineLayerId: 'speedLimitZonesOutlineLayer',
    fallback: FALLBACK_COLOURS.speedLimitZones,
    fillOpacity: 0.15,
  },
}

// Intended to add geofencing zones on the map (source and layer)
export default function setGeofencingZonesLayer(map, geofencingZonesData, layerName) {
  const cfg = ZONE_LAYER_CONFIG[layerName]
  if (!cfg) return

  const colour = colourFromFeature(cfg.fallback)

  map.addSource(cfg.source, {
    type: 'geojson',
    data: geofencingZonesData[cfg.dataKey],
    // Surfaces properties.id as the feature id — lets future feature-state
    // (hover/selected) hooks target individual zones without rebuilding sources.
    promoteId: 'id',
  })

  map.addLayer({
    id: cfg.fillLayerId,
    type: 'fill',
    source: cfg.source,
    layout: {},
    paint: {
      'fill-color': colour,
      'fill-opacity': cfg.fillOpacity,
    },
    filter: ['==', '$type', 'Polygon'],
  })

  map.addLayer({
    id: cfg.outlineLayerId,
    type: 'line',
    source: cfg.source,
    layout: {},
    paint: {
      'line-color': colour,
      'line-width': 2,
    },
    filter: ['==', '$type', 'Polygon'],
  })
}
